/* Mobile menu opener fail-safe.
   The theme's w3-drawer-navigation custom element binds a click on
   .js-open-mobile-menu via its `opener` attribute. This script is a
   delegated, defensive backup that does the same job using event
   delegation on document, so it works even if the custom element
   hasn't yet upgraded by the time the user taps.
   It replicates exactly what w3-drawer would do: add body classes,
   add `.drawer--visible` on the drawer after a tick, and lock scroll.
*/
(function () {
    'use strict';

    function isMobile() {
        return window.matchMedia('(max-width: 1024px)').matches;
    }

    function lockScroll(drawer) {
        try {
            drawer._bodyTopPosition = document.documentElement.scrollTop;
            document.body.style.top = '-' + drawer._bodyTopPosition + 'px';
            document.documentElement.classList.add('lock-scroll');
        } catch (e) { /* noop */ }
    }

    function unlockScroll(drawer) {
        try {
            document.documentElement.classList.remove('lock-scroll');
            window.scrollTo({ left: 0, top: drawer._bodyTopPosition || 0, behavior: 'instant' });
            document.body.style.top = 'unset';
        } catch (e) { /* noop */ }
    }

    function openMobileMenu() {
        var drawer = document.querySelector('w3-drawer-navigation');
        if (!drawer) return;
        /* Prefer the custom-element method if it exists (upgraded) */
        if (typeof drawer.openDrawer === 'function') {
            try { drawer.openDrawer(); return; } catch (e) { /* fall through */ }
        }
        /* Fallback: replicate the open behavior */
        if (drawer.classList.contains('drawer--visible')) return;
        document.body.classList.add('drawer-visible', 'drawer-navigation-visible', 'drawer-navigation--visible');
        setTimeout(function () {
            drawer.classList.add('drawer--visible');
        }, 50);
        setTimeout(function () {
            if (isMobile()) lockScroll(drawer);
            /* Dispatch the custom-event that w3-navigation-mobile listens for */
            try {
                drawer.dispatchEvent(new CustomEvent('drawer--open', {
                    bubbles: true, cancelable: true, composed: false
                }));
            } catch (e) { /* noop */ }
        }, 200);
        /* Wire up close handlers */
        var closeBtns = drawer.querySelectorAll('.js-drawer-close, .drawer__close');
        closeBtns.forEach(function (btn) {
            btn.addEventListener('click', closeMobileMenu, { once: true });
        });
        document.addEventListener('keyup', escHandler);
    }

    function closeMobileMenu() {
        var drawer = document.querySelector('w3-drawer-navigation');
        if (!drawer) return;
        if (typeof drawer.closeDrawer === 'function') {
            try { drawer.closeDrawer(); return; } catch (e) { /* fall through */ }
        }
        drawer.classList.add('drawer-transition-out');
        document.removeEventListener('keyup', escHandler);
        if (isMobile()) unlockScroll(drawer);
        setTimeout(function () {
            drawer.classList.remove('drawer--visible', 'drawer-transition-out');
            document.body.classList.remove('drawer-navigation-visible', 'drawer-navigation--visible');
            if (!document.querySelector('.drawer.drawer--visible')) {
                document.body.classList.remove('drawer-visible');
            }
            try {
                drawer.dispatchEvent(new CustomEvent('drawer--close', {
                    bubbles: true, cancelable: true, composed: false
                }));
            } catch (e) { /* noop */ }
        }, 200);
    }

    function escHandler(e) {
        if (e.keyCode === 27) closeMobileMenu();
    }

    /* Delegated capture-phase click listener — catches the click even if
       the custom element didn't bind in time. */
    document.addEventListener('click', function (e) {
        var opener = e.target.closest && e.target.closest('.js-open-mobile-menu');
        if (!opener) return;
        e.preventDefault();
        openMobileMenu();
    }, false);
})();
